import { render, staticRenderFns } from "./06_0_ControlBodiesList.vue?vue&type=template&id=aacc2cee&scoped=true&"
import script from "./06_0_ControlBodiesList.vue?vue&type=script&lang=js&"
export * from "./06_0_ControlBodiesList.vue?vue&type=script&lang=js&"
import style0 from "./06_0_ControlBodiesList.vue?vue&type=style&index=0&id=aacc2cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacc2cee",
  null
  
)

export default component.exports